// extracted by mini-css-extract-plugin
export var container = "_3p-1";
export var editor = "_3p-2";
export var resizable = "_3p-3";
export var wrapper = "_3p-0";